import { render, staticRenderFns } from "./PriceLabel.vue?vue&type=template&id=5488d56c&scoped=true&"
import script from "./PriceLabel.vue?vue&type=script&lang=js&"
export * from "./PriceLabel.vue?vue&type=script&lang=js&"
import style0 from "./PriceLabel.vue?vue&type=style&index=0&id=5488d56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5488d56c",
  null
  
)

export default component.exports